import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


import { createPinia } from 'pinia';
import 'font-awesome/css/font-awesome.min.css'; // 导入Font Awesome
tailwind.config = {
    theme: {
        extend: {
            colors: {
                primary: '#1E3A8A', // 深蓝色作为主色调
                secondary: '#F59E0B', // 金色作为辅助色
                accent: '#8B5CF6', // 紫色作为强调色
                eye_bg:'#fff5eb',//护眼背景色
                eye_font:'#66513c',//护眼字体色
                moon_bg:'#333333',//夜间
                moon_font:'#d0d0d0',
                love_bg:'#fff0d9',//干眼症
                love_font:'#66513c',
                child_bg:'#e6f0d9',//儿童
                child_font:'#3e5c36',
                warm_font:'#5A5A5A',
                neutral: {
                    100: '#F9FAFB',
                    200: '#F3F4F6',
                    300: '#E5E7EB',
                    400: '#D1D5DB',
                    500: '#9CA3AF',
                    600: '#6B7280',
                    700: '#4B5563',
                    800: '#1F2937',
                    900: '#111827',
                }
            },
            backdropFilter: {
                'blur-sm': 'blur(4px)', // 确保支持 backdrop-blur
            },
            fontFamily: {
                inter: ['Inter', 'sans-serif'],
            },
            animation: {
                'fade-in': 'fadeIn 0.5s ease-in-out',
                'slide-up': 'slideUp 0.5s ease-out',
                'pulse-slow': 'pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite',
            },
            textIndent: {
                '2em': '2em', // 两个汉字宽度（推荐）
                '1em': '1em', // 一个汉字宽度
                '3em': '3em', // 三个汉字宽度
            },
            keyframes: {
                fadeIn: {
                    '0%': { opacity: '0' },
                    '100%': { opacity: '1' },
                },
                slideUp: {
                    '0%': { transform: 'translateY(20px)', opacity: '0' },
                    '100%': { transform: 'translateY(0)', opacity: '1' },
                }
            },
        },
    }
}

const pinia = createPinia();
createApp(App).use(store).use(router).use(pinia).use(ElementPlus).mount('#app')
